const LOADER_STEPS = 4;
const LOADER_IDENTIFIER = "registerLoaderStep";
const LOADER_STEPS_TIMEOUT = 2000;

let currentLoaderStep = 1;

export function initLoader() {
  setInterval(_changeStep, LOADER_STEPS_TIMEOUT);
}

function _changeStep() {
  _hideStep(currentLoaderStep);

  currentLoaderStep =
    currentLoaderStep >= LOADER_STEPS ? 1 : currentLoaderStep + 1;

  _showStep(currentLoaderStep);
}

function _hideStep(stepNumber) {
  $(`#${LOADER_IDENTIFIER}${stepNumber}Icon`).toggleClass(
    "registerLoading__icon--active"
  );
  $(`#${LOADER_IDENTIFIER}${stepNumber}Title`).toggleClass(
    "registerLoading__title--unactive"
  );

  setTimeout(
    () =>
      $(`#${LOADER_IDENTIFIER}${stepNumber}Title`)
        .toggleClass("registerLoading__title--unactive")
        .toggleClass("registerLoading__title--active"),
    1000
  );
}

function _showStep(stepNumber) {
  $(`#${LOADER_IDENTIFIER}${stepNumber}Icon`)
    .delay(500)
    .toggleClass("registerLoading__icon--active");

  $(`#${LOADER_IDENTIFIER}${stepNumber}Title`)
    .delay(500)
    .toggleClass("registerLoading__title--active");
}
